<ng-container *ngTemplateOutlet="getTemplate()" />

<ng-template #longLabelTemplate>
  <span class="td-wb-account-label td-wb-account-label--long">
    <span class="td-wb-account-label__flag-nickname-container">
      <td-wb-icon-flag class="td-wb-account-label__flag"
                       [value]="account.currency" />
      <span class="td-wb-account-label__nickname"
            [innerText]="account.businessLineDescription">
      </span>
    </span>
    <i class="td-wb-account-label__dash td-wb-account-label__dash--first">&ndash;</i>
    <span class="td-wb-account-label__number-desc-container">
      <span class="td-wb-account-label__number"
            [innerText]="account.number"></span>
      @if (!isOfiOrTdctAccount()) {
        <span class="td-wb-account-label__dash">&ndash;</span>
        <span class="td-wb-account-label__desc">
          <span [innerText]="account.currency"></span>&nbsp;<span [innerText]="account.accountTypeDescription"></span>
        </span>
      }
      @if (isAccountClosed()) {
        <span class="td-wb-account-label__desc"
              translate="tdWb.components.accountSelector.CLOSED_LABEL">
        </span>
      }
    </span>
  </span>
</ng-template>

<ng-template #mediumLabelTemplate>
  <span class="td-wb-account-label td-wb-account-label--medium">
    <span class="td-wb-account-label__nickname"
          [innerText]="account.businessLineDescription"></span>
    <i class="td-wb-account-label__dash td-wb-account-label__dash--first">&ndash;</i>
    <span class="td-wb-account-label__number"
          [innerText]="account.number"></span>
    @if (!isOfiOrTdctAccount()) {
      <span class="td-wb-account-label__dash">&ndash;</span>
      <span class="td-wb-account-label__desc">
        <span [innerText]="account.currency"></span>&nbsp;<span [innerText]="account.accountTypeDescription"></span>
      </span>
    }
  </span>
</ng-template>

<ng-template #shortLabelTemplate>
  <span class="td-wb-account-label td-wb-account-label--short">
    <td-wb-icon-flag class="td-wb-account-label__flag"
                     [value]="account.currency" />
    <span class="td-wb-account-label__number td-wb-account-label__number--normal"
          [innerText]="account.number">
    </span>
    @if (!isOfiOrTdctAccount()) {
      <span class="td-wb-account-label__dash">&ndash;</span>
      <span class="td-wb-account-label__type"
            [innerText]="account.accountTypeDescription"></span>
    }
  </span>
</ng-template>

<ng-template #shortNumberDescLabelTemplate>
  <span class="td-wb-account-label td-wb-account-label--short">
    <td-wb-icon-flag class="td-wb-account-label__flag"
                     [value]="account.currency" />
    <span [innerText]="account.number">
    </span>
    <span class="td-wb-account-label__dash">&ndash;</span>
    <span class="td-wb-account-label__type td-wb-account-label__short_number_desc"
          [innerText]="account.description"></span>
  </span>
</ng-template>

<ng-template #singleLineLongLabelTemplate>
  <span class="td-wb-account-label td-wb-account-label--single_line">
    <td-wb-icon-flag class="td-wb-account-label__flag"
                     [value]="account.currency" />
    <span class="td-wb-account-label__number"
          [innerText]="account.number"></span>
    @if (!isOfiOrTdctAccount()) {
      <span class="td-wb-account-label__dash">&ndash;</span>
      <span class="td-wb-account-label__desc">
        <span [innerText]="account.currency"></span>&nbsp;<span [innerText]="account.accountTypeDescription"></span>
      </span>
    }
    <i class="td-wb-account-label__dash td-wb-account-label__dash--first">&ndash;</i>
    <span class="td-wb-account-label__nickname"
          [innerText]="account.businessLineDescription"></span>
  </span>
</ng-template>
